import { Component, OnInit } from '@angular/core';
import { CouponService } from 'src/app/services/coupon/coupon.service';
import { NavController } from '@ionic/angular';
import { AreaService } from 'src/app/services/Area/area.service';

@Component({
  selector: 'app-coupons',
  templateUrl: './coupons.page.html',
  styleUrls: ['./coupons.page.scss'],
})
export class CouponsPage implements OnInit {
allCoupons:any;
dataFlag:boolean =false;
  constructor(
  private couponService:CouponService,
  private navCtrl:NavController,
  private areaService:AreaService
  
  ) { 
    this.couponService.getAllCouponss("Coupon").then((res)=>{
      console.log(res);
      this.allCoupons = res;
      this.dataFlag = true;
    })
  }
  goback(){
    this.navCtrl.navigateBack("/cart-detail");
  }

  applyCoupon(coupon){
    let data = JSON.parse(localStorage.getItem('JobData'));
      console.log(data);
      data.coupon = coupon;
      data.couponId = coupon.id;
      localStorage.setItem('JobData',JSON.stringify(data));
      this.navCtrl.navigateBack('/cart-detail');
  }
  ngOnInit() {
  }
  ionViewDidEnter() {
    this.areaService.showHome=false  
  }
}
